/* skinN°88 Face-Map Skin Diagnosis - shared component
 *
 * Per-zone diagnosis: tap a face area, choose how it feels
 * (Oily / Dry / Comfortable / Flaky / Red-reactive). Unchecked = comfortable.
 * Result = comprehensive skin type + per-zone summary + recommended products
 * (pulled live from curation-skus.json) + continue to build the full set.
 *
 * Mounts into #cw-facemap (wizard Step 1) or via window.CurationFacemap.mount(el,opts).
 * On confirm, dispatches the LOCKED contract event:
 *   document.dispatchEvent(new CustomEvent('cw:diagnosis-complete', {
 *     detail: { skinType:[...], zoneMap:{zoneId:state}, goalHint:'hydration'|null, skip:false }}))
 * skip:true (skinType:[]) = "pick manually / just recommend".
 * Reset: dispatch 'cw:facemap-reset' on document (wizard "Start Over").
 */
(function () {
  'use strict';

  // 5 per-zone states (대표님: 기름짐/건조/편안/각질 + 예민 added for accuracy)
  var STATES = [
    { k: 'oily',      label: 'Oily / shiny',  emoji: '🫧', color: '#c8a87c' },
    { k: 'dry',       label: 'Tight / dry',   emoji: '🏜️', color: '#7fa8c9' },
    { k: 'normal',    label: 'Comfortable',   emoji: '😊', color: '#8bbf9f' },
    { k: 'flaky',     label: 'Flaky / rough', emoji: '🍂', color: '#cda878' },
    { k: 'sensitive', label: 'Red / reactive',emoji: '🔴', color: '#c25450' }
  ];
  function stateMeta(k) { for (var i = 0; i < STATES.length; i++) if (STATES[i].k === k) return STATES[i]; return null; }

  // 9 zones (대표님: 미간/관자놀이/눈가 추가). L/R-symmetric zones share one id (drawn twice).
  var ZONES = [
    { id: 'forehead',   label: 'Forehead',   group: 'T',     shapes: [{ cx: 150, cy: 66,  rx: 56, ry: 25 }] },
    { id: 'temples',    label: 'Temples',    group: 'side',  shapes: [{ cx: 92, cy: 104, rx: 16, ry: 22 }, { cx: 208, cy: 104, rx: 16, ry: 22 }] },
    { id: 'glabella',   label: 'Brow center',group: 'T',     shapes: [{ cx: 150, cy: 104, rx: 15, ry: 17 }] },
    { id: 'eyes',       label: 'Eye corners',group: 'eye',   shapes: [{ cx: 112, cy: 134, rx: 17, ry: 11 }, { cx: 188, cy: 134, rx: 17, ry: 11 }] },
    { id: 'nose',       label: 'Nose',       group: 'T',     shapes: [{ cx: 150, cy: 166, rx: 13, ry: 38 }] },
    { id: 'nose_sides', label: 'Nose sides', group: 'T',     shapes: [{ cx: 126, cy: 196, rx: 10, ry: 13 }, { cx: 174, cy: 196, rx: 10, ry: 13 }] },
    { id: 'cheeks',     label: 'Cheeks',     group: 'U',     shapes: [{ cx: 99, cy: 212, rx: 26, ry: 34 }, { cx: 201, cy: 212, rx: 26, ry: 34 }] },
    { id: 'jaw',        label: 'Jawline',    group: 'lower', shapes: [{ cx: 104, cy: 280, rx: 22, ry: 22 }, { cx: 196, cy: 280, rx: 22, ry: 22 }] },
    { id: 'chin',       label: 'Chin & mouth',group: 'lower',shapes: [{ cx: 150, cy: 304, rx: 32, ry: 25 }] }
  ];
  // draw order: large/low first, small/high last so small zones win the tap
  var DRAW_ORDER = ['cheeks', 'forehead', 'chin', 'jaw', 'nose', 'temples', 'eyes', 'glabella', 'nose_sides'];

  var TYPE_LABELS = { oily: 'Oily', dry: 'Dry', combo: 'Combination', sensitive: 'Sensitive', normal: 'Normal / Balanced' };

  function FaceMap(el, opts) {
    this.el = el;
    this.opts = opts || {};
    this.zoneState = {};                 // zoneState[id] = stateKey | null
    this.openZone = null;                // zone whose picker is open
    this.render();
  }

  FaceMap.prototype.checkedCount = function () {
    var n = 0; for (var k in this.zoneState) if (this.zoneState[k]) n++; return n;
  };

  // ---- comprehensive skin type ----
  FaceMap.prototype.compute = function () {
    var T = ['forehead', 'glabella', 'nose', 'nose_sides'];
    var U = ['cheeks'];
    var s = this.zoneState;
    var oily = [], dryish = [], sens = [], flaky = [];
    ZONES.forEach(function (z) {
      var v = s[z.id];
      if (v === 'oily') oily.push(z.id);
      if (v === 'dry' || v === 'flaky') dryish.push(z.id);
      if (v === 'flaky') flaky.push(z.id);
      if (v === 'sensitive') sens.push(z.id);
    });
    var tOily = oily.filter(function (z) { return T.indexOf(z) >= 0; }).length;
    var uDry = dryish.filter(function (z) { return U.indexOf(z) >= 0; }).length;

    var base;
    if (oily.length === 0 && dryish.length === 0) base = 'normal';
    else if (tOily > 0 && uDry > 0) base = 'combo';
    else if (oily.length > 0 && dryish.length > 0) base = 'combo';
    else if (oily.length > dryish.length) base = 'oily';
    else if (dryish.length > oily.length) base = 'dry';
    else base = 'normal';

    var skinType = [base];
    if (sens.length >= 2) skinType.push('sensitive');
    var goalHint = (flaky.length >= 2 || base === 'dry') ? 'hydration' : null;
    return { skinType: skinType, goalHint: goalHint, zoneMap: this._zoneMapOut() };
  };

  FaceMap.prototype._zoneMapOut = function () {
    var out = {}; for (var k in this.zoneState) if (this.zoneState[k]) out[k] = this.zoneState[k]; return out;
  };

  // ---- rendering ----
  FaceMap.prototype.render = function () {
    this.el.classList.add('cw-fm');
    var n = this.checkedCount();
    this.el.innerHTML =
      '<h3 class="cw-fm-title">How does each area of your skin feel?</h3>' +
      '<p class="cw-fm-hint">Tap a spot on the face, then pick how it usually feels. Skip any you are unsure about.</p>' +
      '<div class="cw-fm-stage">' + this.svg() + '</div>' +
      '<div class="cw-fm-picker" id="cw-fm-picker" hidden></div>' +
      '<div class="cw-fm-checked" id="cw-fm-checked"></div>' +
      '<div class="cw-fm-nav">' +
        '<button type="button" class="cw-fm-btn cw-fm-btn-primary" data-act="result">' +
          (n > 0 ? 'Continue (' + n + ') →' : 'Continue →') +
        '</button>' +
      '</div>' +
      '<button type="button" class="cw-fm-skip" data-act="skip">I’ll pick my skin type myself</button>';
    this.bind();
    this.paint();
  };

  FaceMap.prototype.svg = function () {
    var byId = {}; ZONES.forEach(function (z) { byId[z.id] = z; });
    var zoneShapes = DRAW_ORDER.map(function (id) {
      var z = byId[id];
      return z.shapes.map(function (sh) {
        return '<ellipse class="cw-fm-zone" data-zone="' + z.id + '" cx="' + sh.cx + '" cy="' + sh.cy +
          '" rx="' + sh.rx + '" ry="' + sh.ry + '"></ellipse>';
      }).join('');
    }).join('');
    return '<svg class="cw-fm-svg" viewBox="0 0 300 380" role="img" aria-label="Face map">' +
      '<path class="cw-fm-face" d="M150 26 C90 26 58 78 58 152 C58 228 92 312 150 342 C208 312 242 228 242 152 C242 78 210 26 150 26 Z"/>' +
      '<path class="cw-fm-feature" d="M100 120 q16 -11 32 0"/>' +
      '<path class="cw-fm-feature" d="M168 120 q16 -11 32 0"/>' +
      '<path class="cw-fm-feature" d="M104 140 q12 8 24 0"/>' +
      '<path class="cw-fm-feature" d="M172 140 q12 8 24 0"/>' +
      '<path class="cw-fm-feature" d="M150 150 l-6 42 q6 6 12 0"/>' +
      '<path class="cw-fm-feature" d="M126 262 q24 16 48 0"/>' +
      zoneShapes +
      '</svg>';
  };

  FaceMap.prototype.bind = function () {
    var self = this;
    this.el.querySelectorAll('.cw-fm-zone').forEach(function (node) {
      node.addEventListener('click', function () { self.openPicker(node.dataset.zone); });
    });
    this.el.querySelectorAll('[data-act]').forEach(function (node) {
      node.addEventListener('click', function () { self.act(node.dataset.act); });
    });
  };

  FaceMap.prototype.paint = function () {
    var self = this;
    this.el.querySelectorAll('.cw-fm-zone').forEach(function (node) {
      var v = self.zoneState[node.dataset.zone];
      var m = v ? stateMeta(v) : null;
      node.classList.toggle('is-set', !!v);
      node.classList.toggle('is-open', self.openZone === node.dataset.zone);
      node.style.fill = m ? m.color : '';
      node.style.fillOpacity = m ? '0.62' : '';
    });
    this.renderChecked();
  };

  FaceMap.prototype.renderChecked = function () {
    var wrap = this.el.querySelector('#cw-fm-checked');
    if (!wrap) return;
    var self = this, bits = [];
    ZONES.forEach(function (z) {
      var v = self.zoneState[z.id];
      if (!v) return;
      var m = stateMeta(v);
      bits.push('<button type="button" class="cw-fm-tag" data-edit="' + z.id + '" style="--tag:' + m.color + '">' +
        z.label + ': ' + m.label + ' <span class="cw-fm-tag-x">✕</span></button>');
    });
    wrap.innerHTML = bits.join('');
    wrap.querySelectorAll('.cw-fm-tag').forEach(function (b) {
      b.addEventListener('click', function (e) {
        var id = b.dataset.edit;
        if (e.target.classList.contains('cw-fm-tag-x')) { self.zoneState[id] = null; self.paint(); self.refreshResultBtn(); }
        else self.openPicker(id);
      });
    });
  };

  FaceMap.prototype.refreshResultBtn = function () {
    var btn = this.el.querySelector('[data-act="result"]');
    if (btn) { var n = this.checkedCount(); btn.textContent = n > 0 ? 'Continue (' + n + ') →' : 'Continue →'; }
  };

  FaceMap.prototype.openPicker = function (zoneId) {
    var self = this;
    var zone = ZONES.filter(function (z) { return z.id === zoneId; })[0];
    if (!zone) return;
    this.openZone = zoneId;
    var picker = this.el.querySelector('#cw-fm-picker');
    var cur = this.zoneState[zoneId];
    picker.innerHTML =
      '<div class="cw-fm-picker-title">Your <b>' + zone.label.toLowerCase() + '</b> usually feels…</div>' +
      '<div class="cw-fm-picker-opts">' +
        STATES.map(function (s) {
          return '<button type="button" class="cw-fm-pick' + (cur === s.k ? ' is-cur' : '') + '" data-state="' + s.k +
            '" style="--c:' + s.color + '">' + s.label + '</button>';
        }).join('') +
      '</div>';
    picker.hidden = false;
    picker.querySelectorAll('.cw-fm-pick').forEach(function (b) {
      b.addEventListener('click', function () {
        self.zoneState[zoneId] = b.dataset.state;
        self.openZone = null;
        picker.hidden = true;
        self.paint();
        self.refreshResultBtn();
      });
    });
    this.paint();
    picker.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  };

  FaceMap.prototype.act = function (action) {
    if (action === 'skip') { this.finishSkip(); return; }
    if (action === 'result') { this.finishComplete(this.compute()); return; }  // no result screen - straight to Step 2
  };

  FaceMap.prototype.finishComplete = function (r) {
    document.dispatchEvent(new CustomEvent('cw:diagnosis-complete', {
      detail: { skinType: r.skinType, zoneMap: r.zoneMap, goalHint: r.goalHint, skip: false }
    }));
  };
  FaceMap.prototype.finishSkip = function () {
    document.dispatchEvent(new CustomEvent('cw:diagnosis-complete', {
      detail: { skinType: [], zoneMap: {}, goalHint: null, skip: true }
    }));
  };

  function mount(el, opts) {
    if (!el) return null;
    var inst = new FaceMap(el, opts);
    document.addEventListener('cw:facemap-reset', function () {
      inst.zoneState = {}; inst.openZone = null; inst.render();
    });
    return inst;
  }
  window.CurationFacemap = { mount: mount };

  function autoMount() {
    var el = document.getElementById('cw-facemap');
    if (el && !el.dataset.fmMounted) { el.dataset.fmMounted = '1'; mount(el, {}); }
  }
  if (document.readyState !== 'loading') autoMount();
  else document.addEventListener('DOMContentLoaded', autoMount);
})();
